import makeSlice from '@web/slices/aitems/sliceMaker'
import {initDeliveryTracking} from '@web/slices/deliveryTracking/slice'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDeliveryTracking.fulfilled, (state, {payload}) => {
            const orderDelivery = payload.orderDelivery

            if (orderDelivery) {
                const product = orderDelivery.productOrder
                state.products = [{ecNvMid: `${product?.ecNvMid ?? ''}`}]
            }
        })
    },
})

export default slice.reducer
